var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5556 0C20.2039 0 20.8256 0.257539 21.284 0.715961C21.7425 1.17438 22 1.79614 22 2.44444V19.5556C22 20.2039 21.7425 20.8256 21.284 21.284C20.8256 21.7425 20.2039 22 19.5556 22H2.44444C1.79614 22 1.17438 21.7425 0.715961 21.284C0.257539 20.8256 0 20.2039 0 19.5556V2.44444C0 1.79614 0.257539 1.17438 0.715961 0.715961C1.17438 0.257539 1.79614 0 2.44444 0H19.5556ZM18.9444 18.9444V12.4667C18.9444 11.4099 18.5247 10.3965 17.7774 9.64924C17.0302 8.90201 16.0167 8.48222 14.96 8.48222C13.9211 8.48222 12.7111 9.11778 12.1244 10.0711V8.71444H8.71444V18.9444H12.1244V12.9189C12.1244 11.9778 12.8822 11.2078 13.8233 11.2078C14.2771 11.2078 14.7124 11.3881 15.0333 11.709C15.3542 12.0298 15.5344 12.4651 15.5344 12.9189V18.9444H18.9444ZM4.74222 6.79556C5.2868 6.79556 5.80907 6.57922 6.19415 6.19415C6.57922 5.80907 6.79556 5.2868 6.79556 4.74222C6.79556 3.60556 5.87889 2.67667 4.74222 2.67667C4.1944 2.67667 3.66902 2.89429 3.28165 3.28165C2.89429 3.66902 2.67667 4.1944 2.67667 4.74222C2.67667 5.87889 3.60556 6.79556 4.74222 6.79556ZM6.44111 18.9444V8.71444H3.05556V18.9444H6.44111Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.efcf99c89a93cd66250c6da1e0973ca5.svg";
export { ForwardRef as ReactComponent };